import { SupportedFileType } from '@/shared/models/common.models'
import { HelperUtils } from '@/shared/util/helper-utils'
import { AxiosResponse } from 'axios'
import { CommonOpenFileParams } from '@/api/resources/common/shared/models/common.models'

export class FileUtils {
    static openFile({ blob, type = SupportedFileType.PDF, newWindowTabTitle }: CommonOpenFileParams): void {
        const url = URL.createObjectURL(new Blob([blob], { type }))
        if (type === SupportedFileType.PDF) {
            HelperUtils.openPDF({ url }, newWindowTabTitle)
        } else {
            HelperUtils.openUrl({ url })
        }
    }

    static downloadFile(blob: Blob, filename: string, type: SupportedFileType): void {
        const url = URL.createObjectURL(new Blob([blob], { type }))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        link.remove()
    }

    static getFilenameFromHeaderRequest(axiosResponse: AxiosResponse): string {
        const contentDisposition = axiosResponse?.headers['content-disposition']
        if (contentDisposition) {
            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
            const matches = filenameRegex.exec(contentDisposition)
            if (matches != null && matches[1]) {
                return matches[1].replace(/['"]/g, '')
            }
        }
        return ''
    }
}
